/**
 * Agrega un punto final a un string si no lo tenía
 */
export function addPeriod(message: string) {
  return message.trim().endsWith('.') ? message : message + '.';
}
